const theme = {
  darkMode: true,
  padding: 0,
  margin: 0,
  boundaryGap: false,
  colors: {
    axisLine: '#002649',
    axisPointer: '#002649',
    splitLine: '#002649',
    legendText: '#FFF',
    text: '#FFF',
    title: '#EEF1FA',
    subTitle: '#B9B8CE',
    tooltipBorder: '#344854',
    tooltipBg: '#344854',
    tooltipText: '#fff',
    defaultLegend: '#EAEDF0',
  },

  grid3D: {
    axisTick: { show: false },
    splitLine: { lineStyle: { color: '#002649' } },
    axisLabel: {
      color: '#EAEDF0',
    },
    axisLine: {
      lineStyle: {
        color: '#002649',
      },
    },
    axisPointer: {
      lineStyle: {
        color: '#002649',
      },
      label: {
        show: false,
      },
    },
    viewControl: {
      alpha: 20,
      beta: 1,
    },
  },
  nameTextStyle: {
    color: '#98A8B3',
    fontSize: 14,
    fontFamily: 'Inter',
    fontWeight: 400,
  },
  axisPointerConfig: {
    lineStyle: { color: '#98A8B3', width: 1 },
  },
  visualMap: {
    show: true,
    inRange: {
      color: [
        '#4575b4',
        '#74add1',
        '#abd9e9',
        '#e0f3f8',
        '#ffffbf',
        '#fee090',
        '#fdae61',
        '#f46d43',
        '#d73027',
        '#a50026',
      ],
    },
  },
};

export default theme;
